import Hero from "@/components/site/Hero";
import Ticker from "@/components/site/Ticker";
import Services from "@/components/site/Services";
import Standards from "@/components/site/Standards";
import Trust from "@/components/site/Trust";
import TradePartners from "@/components/site/TradePartners";
import Accreditations from "@/components/site/Accreditations";
import AreasServed from "@/components/site/AreasServed";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";

export default function Home({ onNav }) {
  const BASE = typeof window !== "undefined" ? window.location.origin : "";
  const desc =
    "FS Restoration Group (Final Sweep Solutions) — Swan Hill's only dedicated IICRC certified forensic cleaning and property restoration provider. Servicing regional Victoria & NSW, 24/7.";
  return (
    <>
      <title>FS Restoration Group | Forensic Cleaning & Property Restoration</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={`${BASE}/`} />
      <meta property="og:title" content="FS Restoration Group | Forensic Cleaning & Property Restoration" />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={`${BASE}/`} />
      <Hero onNav={onNav} />
      <Accreditations />
      <Ticker />
      <Services />
      <Standards />
      <Trust />
      <Testimonials />
      <Contact />
      <AreasServed />
    </>
  );
}
